import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Button } from "antd";

import yandexLatinIcon from "../../assets/img/yandex-icon-latin.svg";
import yandexRuIcon from "../../assets/img/yandex-icon-ru.svg";
import { browserLang } from "../../i18n";

const CYRILLIC_LANGUAGES = new Set(["ru", "be", "bg"]);

export const YandexSignInButton = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const icon = CYRILLIC_LANGUAGES.has(browserLang)
    ? yandexRuIcon
    : yandexLatinIcon;

  const next = searchParams.get("next");
  const href = next
    ? `/yandex/login/?next=${encodeURIComponent(next)}`
    : "/yandex/login/";

  return (
    <Button
      size="large"
      block
      icon={
        <img
          src={icon}
          alt=""
          style={{ width: 20, height: 20, display: "block" }}
        />
      }
      href={href}
    >
      {t("app.yandexSignin")}
    </Button>
  );
};
